/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./settings-block.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./settings-block.component";
var styles_SettingsBlockComponent = [i0.styles];
var RenderType_SettingsBlockComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_SettingsBlockComponent, data: {} });
export { RenderType_SettingsBlockComponent as RenderType_SettingsBlockComponent };
export function View_SettingsBlockComponent_0(_l) { return i1.ɵvid(0, [i1.ɵncd(null, 0)], null, null); }
export function View_SettingsBlockComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "cc-settings-block", [], null, null, null, View_SettingsBlockComponent_0, RenderType_SettingsBlockComponent)), i1.ɵdid(1, 114688, null, 0, i2.SettingsBlockComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var SettingsBlockComponentNgFactory = i1.ɵccf("cc-settings-block", i2.SettingsBlockComponent, View_SettingsBlockComponent_Host_0, {}, {}, ["*"]);
export { SettingsBlockComponentNgFactory as SettingsBlockComponentNgFactory };
